import { applyMiddleware, createStore } from 'redux';
import rootReducer from './reducers';
import { adaptivePracticeActions, userAction, smartSheetActions } from './actionCreators';
import thunk from 'redux-thunk';
import { ls } from '../localStorage';

const persistedState = ls.getStateFromLocal();
const store = createStore(rootReducer, persistedState, applyMiddleware(thunk));

export { store, userAction, adaptivePracticeActions, smartSheetActions }